
import React from 'react';
import { useSessionStore } from '@/store/sessionStore';
import SessionActions from './SessionActions';
import SessionInfo from './SessionInfo';
import SessionSettings from './SessionSettings';

const SessionControls: React.FC = () => {
    const {
        currentSessionId,
        currentSessionStatus,
        isLoading,
        startNewSession,
        startFollowUpSession,
        error,
    } = useSessionStore();

    const handleNewSession = async () => {
        await startNewSession({ session_title: "New Repoburg Session" });
    };

    const handleFollowUp = async () => {
        if (!currentSessionId) return;
        await startFollowUpSession(currentSessionId);
    };
    
    return (
        <div className="space-y-1">
            <SessionActions
                onNewSession={handleNewSession}
                onFollowUp={handleFollowUp}
                isLoading={isLoading}
                currentSessionId={currentSessionId}
                currentSessionStatus={currentSessionStatus}
            />

            {error && <p className="text-red-500 text-xs p-2 bg-red-100 dark:bg-red-900/30 rounded-md">Error: {error}</p>}

            <SessionInfo />
            <SessionSettings />
        </div>
    );
};

export default SessionControls;